import { render, staticRenderFns } from "./escalationReview.vue?vue&type=template&id=4d6baef8&scoped=true"
import script from "./escalationReview.vue?vue&type=script&lang=js"
export * from "./escalationReview.vue?vue&type=script&lang=js"
import style0 from "./escalationReview.vue?vue&type=style&index=0&id=4d6baef8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6baef8",
  null
  
)

export default component.exports